import { render, staticRenderFns } from "./BrokerLogo.vue?vue&type=template&id=a38d185a&scoped=true"
import script from "./BrokerLogo.vue?vue&type=script&lang=js"
export * from "./BrokerLogo.vue?vue&type=script&lang=js"
import style0 from "./BrokerLogo.vue?vue&type=style&index=0&id=a38d185a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38d185a",
  null
  
)

export default component.exports